import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route } from 'react-router';

import routes from './routes/routes';

import { browserHistory } from 'react-router'
// import AppComponent from './js/app.js';
// import  SectionIntro from './js/sectionIntro.js';
// import  SectionSendMoney from './js/sectionSendMoney.js';
// import  createElement from './js/createElement.js';

var store = require('./js/redux/redux-store.js');



// var Provider = require('react-redux').Provider;
import { Provider } from 'react-redux';

var initialState = window.__INITIAL_STATE__;
store = store.configureStore(initialState);

ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory} onUpdate={() => window.scrollTo(0, 0)}>{routes}</Router>
  </Provider>,
  document.getElementById('app')
)


// WEBPACK FOOTER //
// ./client-render.js